import i18n from "../i18n";

// القاعدة الذهبية: الاسم يُعرض بلغة الواجهة الحالية، ويعود للاسم الآخر إن كان الحقل فارغاً.
const isArabic = () => (i18n.language || "ar").startsWith("ar");

// يدعم كل أشكال التسمية في قاعدة البيانات: name_ar / name_en / name / legal_name.
export const localName = (row, fallback = "") => {
  if (!row) return fallback;
  const ar = row.name_ar;
  const en = row.name_en || row.name || row.legal_name;
  return (isArabic() ? ar || en : en || ar) || fallback;
};

// لأي حقل ثنائي اللغة آخر: localPick(row, "employee_name") أو "account_name" أو "description".
export const localPick = (row, base, fallback = "") => {
  if (!row) return fallback;
  const ar = row[`${base}_ar`];
  const en = row[`${base}_en`] || row[base];
  return (isArabic() ? ar || en : en || ar) || fallback;
};

export const localDesc = (row, fallback = "") => localPick(row, "description", fallback);

export { isArabic };
